import { render, staticRenderFns } from "./errorAccess.vue?vue&type=template&id=4644339a&scoped=true&"
var script = {}
import style0 from "./errorAccess.vue?vue&type=style&index=0&id=4644339a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4644339a",
  null
  
)

export default component.exports